/**
 * Case-insensitive substring match on any of the given dot-path fields (OR).
 * Central text-search matcher for list rows, dropdown options, and drive items.
 *
 * @param {Object} item Row object to test.
 * @param {string} query Raw search text from the input.
 * @param {string[]} searchFields Dot-path field names (e.g. `job_number`, `nested.key`).
 * @returns {boolean} True when query is empty/whitespace or any field contains the query.
 */
export function itemMatchesSearchQuery(item, query, searchFields) {
  if (!query?.trim()) {
    return true;
  }
  const normalized = query.toLowerCase();
  return searchFields.some((field) => {
    const value = field.split(".").reduce((obj, key) => obj?.[key], item);
    return value?.toString().toLowerCase().includes(normalized);
  });
}
